<template>
  <Card class="hover:!border-brand-typo bg-shape cursor-pointer !p-0 flex relative overflow-hidden" :class="classes">
    <ImageComposition :layers="props.layers" class="bg-shape" />
  </Card>
  <div class="flex flex-col gap-1">
    <span class="text-xs text-typo !m-0 font-bold">
      {{ meta.name }}
    </span>

    <span v-if="meta.width && meta.height" class="text-xs text-typo-secondary !m-0"> {{ meta.width }} x {{ meta.height }} {{ meta.unit }} </span>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { Card, ImageComposition } from "prism";

const props = defineProps({
  isSelected: Boolean,
  meta: Object,
  layers: Array,
});

const classes = computed(() => {
  return {
    "!border-brand-typo": props.isSelected,
  };
});
</script>
